import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import StatusChange from '../../StatusChange';
import getIsItemEnabled from '../utils/getIsInventoryItemEnabled';
import useGetPreviousInventoryStatus from '../../StatusChange/hooks/useGetPreviousInventoryStatus';
import useInventoryStatusChange from '../../StatusChange/hooks/useInventoryStatusChange';
import useShouldRedirectBack from '../hooks/useShouldRedirectBack';
import ProgressBarUI, { ItemUI } from '../ProgressBarUI';
import { DEALER_DATA_COOKIE_NAME } from '../../../utils/constants';
import { selectCurrentVehicle, selectCurrentVehicleUrlQueryString } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
const VEHICLE_DETAILS_STEP = 3;
const scrollIntoView = (ref) => {
    requestAnimationFrame(() => {
        var _a;
        (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth',
        });
    });
};
const InventoryProgressBar = ({ fields, variant }) => {
    var _a, _b, _c, _d;
    const items = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.items;
    const itemKeys = items === null || items === void 0 ? void 0 : items.map(item => item === null || item === void 0 ? void 0 : item.name);
    const currentVehicle = useAppSelector(selectCurrentVehicle);
    const queryParams = useAppSelector(selectCurrentVehicleUrlQueryString);
    const [cookies] = useCookies([DEALER_DATA_COOKIE_NAME]);
    const dealerData = cookies === null || cookies === void 0 ? void 0 : cookies.dealerData;
    const dealerCodeFromCookie = dealerData === null || dealerData === void 0 ? void 0 : dealerData.dealerCode;
    const itemsEnabledState = items === null || items === void 0 ? void 0 : items.map((_, index) => getIsItemEnabled(index, currentVehicle, dealerCodeFromCookie));
    const enableSwipe = itemsEnabledState[1] === true;
    const renderItem = (item, extendedType, ref) => {
        const isItemEnabled = !!itemsEnabledState[itemKeys === null || itemKeys === void 0 ? void 0 : itemKeys.findIndex(key => key === item.key)];
        return (_jsx(ItemUI, { ref: ref, item: item, variant: variant, isItemEnabled: isItemEnabled, extendedType: extendedType, queryParams: queryParams, scrollIntoViewCallback: scrollIntoView }, item === null || item === void 0 ? void 0 : item.key));
    };
    // steps ['Choose Model', 'Pick Dealer', 'Availability', 'Vehicle Details']
    const activeStep = (_d = (_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.items.findIndex(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.isActive) === null || _a === void 0 ? void 0 : _a.value) === '1'; });
    const { previousStatus } = useGetPreviousInventoryStatus();
    const { shouldRedirectBack, redirectUrl } = useShouldRedirectBack(activeStep, items, dealerCodeFromCookie);
    const { openModal, modalMessage, redirectOnClose, updateStatusInUrl } = useInventoryStatusChange(previousStatus, activeStep !== VEHICLE_DETAILS_STEP);
    if (shouldRedirectBack) {
        return _jsx(Redirect, { to: redirectUrl || '' });
    }
    return (_jsxs(_Fragment, { children: [_jsx(ProgressBarUI, { fields: fields, variant: variant, renderItem: renderItem, enableSwipe: enableSwipe, shouldOverrideMobileHeader: false }), _jsx(StatusChange, { openModal: openModal, modalMessage: modalMessage, redirectOnClose: redirectOnClose, redirectUrl: redirectUrl || '', updateStatusInUrl: updateStatusInUrl })] }));
};
export default InventoryProgressBar;
